const getMonthByNumber = (number) => {
    switch (parseInt(number)) {
        case 1:
            return app.$i18n.t('January');
        case 2:
            return app.$i18n.t('February');
        case 3:
            return app.$i18n.t('March');
        case 4:
            return app.$i18n.t('April');
        case 5:
            return app.$i18n.t('May');
        case 6:
            return app.$i18n.t('June');
        case 7:
            return app.$i18n.t('July');
        case 8:
            return app.$i18n.t('August');
        case 9:
            return app.$i18n.t('September');
        case 10:
            return app.$i18n.t('October');
        case 11:
            return app.$i18n.t('November');
        case 12:
            return app.$i18n.t('December');
        default:
            return app.$i18n.t('Not exists');
    }
};

const getMonthByNumber2 = (number) => {
    switch (parseInt(number)) {
        case 1:
            return 'ENERO';
        case 2:
            return 'FEBRERO';
        case 3:
            return 'MARZO';
        case 4:
            return 'ABRIL';
        case 5:
            return 'MAYO';
        case 6:
            return 'JUNIO';
        case 7:
            return 'JULIO';
        case 8:
            return 'AGOSTO';
        case 9:
            return 'SEPTIEMBRE';
        case 10:
            return 'OCTUBRE';
        case 11:
            return 'NOVIEMBRE';
        case 12:
            return 'DICIEMBRE';
        default:
            return 'No existe';
    }
}

const getDayName = (dateString) => {
    const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    const date = new Date(dateString);
    const dayIndex = date.getDay();
    return days[dayIndex];
}

// Helper Planilla
function getSubmotivo(departmentId, metodoDePago) {
    switch (departmentId) {
        // MANTENIMIENTO
        case 7:
            // HABERES MANTENIMIENTO - Titanic de Rosymar
            // 146 → 1ERA QUINCENA (Quincenal)
            // 147 → 2DA QUINCENA (Mensual)
            return metodoDePago === "Quincenal" ? 146 : 147;
        // OPERACIONES (CONDUCTORES)
        case 8:
            // HABERES MANTENIMIENTO - Titanic de Rosymar
            // 146 → 1ERA QUINCENA (Quincenal)
            // 147 → 2DA QUINCENA (Mensual)
            return metodoDePago === "Quincenal" ? 132 : 133;
        // SEGURIDAD (VIGILANCIA)
        case 10:
            // HABERES VIGILANCIA - Titanic de Rosymar
            // 95 → 1ERA QUINCENA (Quincenal)
            // 145 → 2DA QUINCENA (Mensual)
            return metodoDePago === "Quincenal" ? 95 : 145;

        // Puedes seguir agregando más casos aquí...
        default:
            return null;
    }
}


export { getMonthByNumber, getDayName, getSubmotivo, getMonthByNumber2 };
